import { ThemeOptions } from '@mui/material/styles/createTheme';
import { Components, Theme } from '@mui/material';

export const MuiSelectStyle: Components<Theme>['MuiSelect'] = {
  styleOverrides: {
    root: ({ theme }: { theme: ThemeOptions }) => ({
      fieldset: {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        borderColor: theme?.palette?.neutralGray6?.main ?? '#6A6E79',
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        borderColor: theme?.palette?.primary?.main ?? '#0063A3',
      },
      '& .MuiSelect-select': {
        paddingTop: '10px',
        paddingLeft: '12px',
        paddingBottom: '10px',
        minHeight: '24px',
      },
      '&.Mui-focused .MuiSelect-select': {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        outline: `2px solid ${theme?.palette?.secondary?.main ?? '#252A2E'}`,
        outlineOffset: '2px',
      },
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      backgroundColor: theme?.palette?.white?.main ?? '#FFF',
      '&.Mui-error': {
        '.MuiOutlinedInput-notchedOutline': {
          borderWidth: '2px',
        },
      },
    }),
  },
};
